import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const isFirstFloorDefinition = definitionFactory({
  key: 'is_first_floor',
  mapper: jsonQueryValue => {
    if (jsonQueryValue === false) {
      return [
        {
          label: 'Не первый этаж',
          value: jsonQueryValue,
        },
      ];
    }

    return [];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'is_first_floor', options);
  },
});

export const isLastFloorDefinition = definitionFactory({
  key: 'is_last_floor',
  mapper: jsonQueryValue => {
    if (jsonQueryValue === true) {
      return [
        {
          label: 'Только последний этаж',
          value: jsonQueryValue,
        },
      ];
    }

    if (jsonQueryValue === false) {
      return [
        {
          label: 'Не последний этаж',
          value: jsonQueryValue,
        },
      ];
    }

    return [];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'is_last_floor', options);
  },
});
